// extracted by mini-css-extract-plugin
export default {"card":"Panel_card__dPCib","box":"Panel_box__Eyery","title":"Panel_title__x4gYd","iconWrapper":"Panel_iconWrapper__hMr5+"};